import { render, staticRenderFns } from "./TokenDialog2.vue?vue&type=template&id=1bdfa68a&"
import script from "./TokenDialog2.vue?vue&type=script&lang=js&"
export * from "./TokenDialog2.vue?vue&type=script&lang=js&"
import style0 from "./TokenDialog2.vue?vue&type=style&index=0&id=1bdfa68a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports